export const ELECTRICAL_SELECT_KEYS = [
  'supply_type_id',
  'supply_cable_type_id',
  'supply_profile_id',
  'main_switch_value_id',
  'main_switch_type_id',
  'overvoltage_protection_type_id',
  'protection_before_overvoltage_protection_value_id',
] as const;

export const ELECTRICAL_CHECKBOX_KEYS = [
  'supply_as_terminal_block_check',
  'service_socket',
  'main_switch_check',
  'overvoltage_protection_check',
  'protection_before_overvoltage_protection_check',
] as const;

export const ELECTRICAL_TEXT_KEYS = [
  'supply_label',
  'supply_note',
] as const;

export const WIZARD_SELECT_KEYS = [
  'switch_product_name_id',
  'lighting_product_name_id',
  'shading_product_name_id',
  'heating_product_name_id',
  'contact_sensor_product_name_id',
  'movement_sensor_product_name_id',
  'wifi_hertz',
  'ventillation_product_name_id',
] as const;

export const NHC_MAX_UNIT_KEY = 'nhc_max_unit_number_in_row';

export type ElectricalSelectKey = typeof ELECTRICAL_SELECT_KEYS[number];
export type ElectricalCheckboxKey = typeof ELECTRICAL_CHECKBOX_KEYS[number];
export type ElectricalTextKey = typeof ELECTRICAL_TEXT_KEYS[number];
export type ElectricalPropertyKey = ElectricalSelectKey | ElectricalCheckboxKey | ElectricalTextKey | typeof NHC_MAX_UNIT_KEY;
export type WizardSelectKey = typeof WIZARD_SELECT_KEYS[number];

export function isElectricalSelectKey(key: ElectricalPropertyKey): key is ElectricalSelectKey {
  return ELECTRICAL_SELECT_KEYS.some((selectKey) => selectKey === key);
}

export function isElectricalCheckboxKey(key: ElectricalPropertyKey): key is ElectricalCheckboxKey {
  return ELECTRICAL_CHECKBOX_KEYS.some((checkboxKey) => checkboxKey === key);
}

export function isElectricalTextKey(key: ElectricalPropertyKey): key is ElectricalTextKey {
  return ELECTRICAL_TEXT_KEYS.some((textKey) => textKey === key);
}
